/**
 *
 * Asynchronously loads the component for FlightChange
 *
 */

import React from 'react';

import { lazyLoad } from 'utils/loadable';
import { LoadingContainer } from 'app/components/LoadingContainer';

export const FlightChange = lazyLoad(
  () => import('./FlightChangePage'),
  module => module.FlightChange,
  { fallback: <LoadingContainer loading /> },
);
